import { FC } from "react"
import { IBestSellerProductsModel } from "../core/_models"

type IProps = {
    item: IBestSellerProductsModel
}

const BestSellerProductsCardRow:FC<IProps> = ({item}) => {
  return (
    <tr>
        <td className="hsb-td-strong">{item.name}</td>
        <td className="hsb-td-mono">{item.barcode}</td>
        <td className="hsb-td-end hsb-td-strong">{item.sold_quantity}</td>
    </tr>
  )
}

export default BestSellerProductsCardRow